import BitmapBaseValue from 'core/display/context/texts/BitmapBaseValue'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'

export default class BetTextCurrency extends BitmapBaseValue{
  constructor(data) {
    super(data)
    if(data.hide) {
      this.visible = false
    }

    signal.on('STATE:IN:FB-ADD', () => {
      let freeBetValue = game.models.FreebetsModel.get().betValue
      let winLinesQuantity = game.models.SpinModel.get().lines
      this.update(FormatService.currency(freeBetValue * winLinesQuantity))
    })

    signal.on('FREEBET:END', () => {
      this.update(FormatService.currency(game.models.BetModel.getValue()))
    })

    signal.on('MODEL:BET', (value) => {
      this.update(FormatService.currency(value))
    })
  }
}
